import { render, staticRenderFns } from "./BtnModal.vue?vue&type=template&id=47d15ce5&scoped=true&"
import script from "./BtnModal.vue?vue&type=script&lang=js&"
export * from "./BtnModal.vue?vue&type=script&lang=js&"
import style0 from "./BtnModal.vue?vue&type=style&index=0&id=47d15ce5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d15ce5",
  null
  
)

export default component.exports